/**
 * Wertia Finanz · Palette UFFICIALE per i grafici (Feb 2026).
 *
 * - PALETTE: 5 tonalità del brand (sabbia, oro chiaro, oro scuro, stone, cocoa)
 *   usate quando si visualizzano valori NEUTRI (es. ripartizione patrimonio,
 *   distribuzione spese, segmenti di una donut con dati non semantici).
 *
 * - SEMANTIC: 3 colori riservati a stati semantici:
 *     ERROR    → lacune, deficit, valori critici
 *     SUCCESS  → positivo, copertura piena, target raggiunto
 *     INFO     → "altro", info neutra (es. compagnia esterna)
 *
 * NOTA: NON usare colori al di fuori di questa palette nei grafici Recharts.
 */
export const WERTIA_CHART_PALETTE = [
  "#E0D9CE", // sand    (sfondo / supporto / dati di partenza)
  "#D7A93F", // gold    (accento principale Wertia chiaro)
  "#B2872D", // gold-dark (accento principale Wertia scuro)
  "#433E3D", // stone   (testo / categoria neutra forte)
  "#2E2622", // cocoa   (ink / valore principale)
];

export const CHART_COLOR = {
  SAND:      "#E0D9CE",
  GOLD:      "#D7A93F",
  GOLD_DARK: "#B2872D",
  STONE:     "#433E3D",
  COCOA:     "#2E2622",
  // Semantic
  ERROR:     "#FF5757", // lacune, deficit, critico
  SUCCESS:   "#389D6D", // positivo, perfetto, target
  INFO:      "#2E9EDF", // altro, neutro informativo
};

/**
 * Restituisce il colore della palette in posizione i (con loop modulare).
 */
export function paletteColor(i) {
  return WERTIA_CHART_PALETTE[i % WERTIA_CHART_PALETTE.length];
}

/**
 * Assi e griglie Recharts — toni neutri coerenti col brand.
 */
export const CHART_AXIS = {
  grid:   "#E0D9CE",
  axis:   "#433E3D",
  tick:   "#433E3D",
  cursor: "#B2872D",
};
